import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import Socket from "socket";
import Routes from "./routes";
import store from "redux/store/index";
import Loading from "shared/components/loader";
import * as gameParamAction from "redux/gameParams/actions";
import * as loaderAction from "redux/loader/action";
import * as gameAction from "redux/game/action";

const MobileWebApp = (props) => {
  const [flag, set_flag] = useState(false);
  const mobile_app = useSelector((state) => state.gameReducer.mobile_app);

  const user_in_game = (users, currentUser) => {
    for (let user of users) {
      if (user.user_id === currentUser.userId) {
        return true;
      }
    }
    return false;
  };

  const rejoin_player = () => {
    let storestate = store.getStore().getState();
    const roomObj = storestate.gameReducer.roomObj || {};
    const sessionObj = storestate.gameReducer.sessionObj || {};

    const users = roomObj.users || [];
    const currentUser = storestate.gameReducer.currentUser || null;
    if (Object.keys(roomObj).length > 0) {
      if (
        roomObj.active_game &&
        Object.keys(currentUser).length > 0 &&
        user_in_game(users, currentUser)
      ) {
        const data = {
          action: "player-rejoin",
          joinCode: roomObj?.join_code,
          userId: currentUser?.userId
        };
        Socket.sendMessage(data);
      } else {
        props.setIsLoading(false);
      }
    } else if (Object.keys(sessionObj).length > 0) {
      if (sessionObj?.session_id && sessionObj?.valid) {
        const data = {
          action: "session-rejoin",
          userId: currentUser?.userId,
          sessionId: sessionObj.session_id,
          teamCode: sessionObj.id
        };
        Socket.sendMessage(data);
      }
    } else {
      props.setIsLoading(false);
    }
  };

  const connectToServer = () => {
    props.setIsLoading(true);
    props
      .getAllParams()
      .then(async (resp) => {
        const url = `${resp.payload.data.game_api}/${resp.payload.data.game_api_stage}`;
        Socket.connect(url, () => {
          set_flag(true);
          rejoin_player();
          // props.setIsLoading(false);
          console.log(
            "%c#####SOCKET-CONNECTED#####",
            "background: green; padding: 2px;"
          );
        });
      })
      .catch((err) => {
        console.log(
          "%c#####Failed to connect to socket#####",
          "background: red; padding: 2px;"
        );
        console.log("errrr", err);
      });
  };

  const refresh_websocket = () => {
    props.setIsLoading(true);
    Socket.connect(null, () => {
      console.log(
        "%c#####SOCKET-CONNECTED#####",
        "background: green; padding: 2px;"
      );
      rejoin_player();
    });
  };

  const rejoin_viewer = (e) => {
    const action = e.data.action;
    if (action === "rejoin-mobile-web-app-viewer") {
      const join_code = e.data.join_code;
      const data = {
        action: "leave-game-viewer",
        joinCode: join_code
      };
      props.setIsLoading(true);
      Socket.sendMessage(data);

      Socket.connect(null, () => {
        console.log(
          "%c#####SOCKET-CONNECTED#####",
          "background: green; padding: 2px;"
        );
        let data = {
          action: "join-game-viewer",
          joinCode: join_code
        };
        Socket.sendMessage(data);
      });
    }
  };

  const onFocus = () => {
    Socket.disconnect();
    refresh_websocket();
  };

  // const offFocus = () => {
  //   Socket.disconnect();
  // };

  useEffect(() => {
    connectToServer();
  }, []);

  useEffect(() => {
    if (mobile_app) {
      window.addEventListener("message", rejoin_viewer);
      return () => {
        window.removeEventListener("message", rejoin_viewer);
      };
    } else {
      window.addEventListener("focus", onFocus);
      // window.addEventListener("blur", offFocus);
      return () => {
        window.removeEventListener("focus", onFocus);
        // window.removeEventListener("blur", offFocus);
      };
    }
  }, [mobile_app]);

  return (
    <>
      <Loading />
      {flag && (
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    getAllParams: () => dispatch(gameParamAction.getAllParams()),
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    show_leave_game: (data) => dispatch(gameAction.show_leave_game(data)),
    setSession: (data) => dispatch(gameAction.setSession(data)),
    endGame: (data) => dispatch(gameAction.endGame(data))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MobileWebApp);
